import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ReservationItem } from '../../core/models/show.model';

export interface ReservationCancelDialogData {
  reservation: ReservationItem;
}

@Component({
  selector: 'app-reservation-cancel-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule],
  templateUrl: './reservation-cancel-modal.component.html',
  styleUrl: './reservation-cancel-modal.component.scss'
})
export class ReservationCancelModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReservationCancelDialogData,
    private readonly dialogRef: MatDialogRef<ReservationCancelModalComponent>
  ) { }

  close(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  get hasOrderItems(): boolean {
    return (this.data.reservation.orderItems?.length ?? 0) > 0;
  }
}
